import { useState, useEffect } from "react";
import { useProductos } from "../../../../contexto/provider/ProductosContext.js";
import { useCategorias } from "../../../../contexto/provider/CategoriasContext.js";

import "./formCreacion.css";

export default function FormEditarProducto() {
  const { productos, cargarProductos, actualizarProducto } = useProductos();
  const { categorias, cargarCategorias, cargando } = useCategorias();
  const [mensaje, setMensaje] = useState("");
  const [productoId, setProductoId] = useState(null);

  const [formData, setFormData] = useState({
    nombre: "",
    precio_unitario: "",
    costo_unitario: "",
    Clase: "",
    categoria: "",
    estado: "True",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    cargarProductos();
    cargarCategorias();
  }, [cargarProductos, cargarCategorias]);
  //  seleccionar producto
  const handleSeleccionarProducto = (codigo) => {
    console.log("ID directo:", codigo);
    setProductoId(codigo);
    const producto = productos.find((p) => String(p.Codigo) === String(codigo));

    if (!producto) return;

    setFormData({
      nombre: producto.nombre || "",
      precio_unitario: producto.precio_unitario || "",
      costo_unitario: producto.costo_unitario || "",
      Clase: producto.Clase || "",
      categoria: producto.categoria || "",
      estado: producto.estado ? "True" : "False",
    });
  };

  //  cambios en inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("ID producto:", productoId);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //  submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("productoId:", productoId);
    console.log("formData:", formData);

    if (!productoId) {
      console.warn("No hay producto seleccionado");
      return;
    }

    setIsLoading(true);
    setIsSuccess(false);

    const payload = {
      ...formData,
      precio_unitario: Number(formData.precio_unitario),
      costo_unitario: Number(formData.costo_unitario),
    };
    console.log("Payload:", payload);
    const resultado = await actualizarProducto(productoId, payload);
    console.log("Resultado:", resultado);

    if (resultado?.success) {
      const productoActualizado = resultado.data?.[0];

      setMensaje(`Producto actualizado: ${productoActualizado?.nombre || ""}`);
      setIsSuccess(true);
    } else {
      setMensaje("Error al actualizar producto");
      setIsSuccess(false);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (isSuccess) {
      const timer = setTimeout(() => {
        setIsSuccess(false);
        setMensaje("");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isSuccess]);

  return (
    <form className="form-card" onSubmit={handleSubmit}>
      <h2 className="form-title">Editar Producto</h2>

      {/* Selector */}
      <div className="form-group">
        <label className="form-label">Seleccionar Producto</label>

        <select
          onChange={(e) => {
            const value = e.target.value;
            console.log("🟡 value select:", value);
            console.log("🟡 tipo:", typeof value);
            handleSeleccionarProducto(value);
          }}
          className="form-input"
        >
          <option value="">Seleccione Producto</option>
          {productos.map((p) => (
            <option key={p.Codigo} value={p.Codigo}>
              {p.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* Fila 1 */}
      <div className="form-group-row">
        <div className="form-group">
          <label className="form-label">Nombre</label>
          <input
            name="nombre"
            value={formData.nombre}
            onChange={handleInputChange}
            className="form-input"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Clase</label>
          <select
            name="Clase"
            value={formData.Clase}
            onChange={handleInputChange}
            className="form-input"
            required
          >
            <option value="">Seleccione Clase</option>
            <option value="linea">Linea</option>
            <option value="insumo">Insumo</option>
          </select>
        </div>
      </div>

      {/* Fila 2 */}
      <div className="form-group-row">
        <div className="form-group">
          <label className="form-label">Precio Unitario</label>
          <input
            type="number"
            name="precio_unitario"
            value={formData.precio_unitario}
            onChange={handleInputChange}
            className="form-input"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Costo Unitario</label>
          <input
            type="number"
            name="costo_unitario"
            value={formData.costo_unitario}
            onChange={handleInputChange}
            className="form-input"
          />
        </div>
      </div>

      {/* Fila 3 */}
      <div className="form-group-row">
        <div className="form-group">
          <label className="form-label">Categoría</label>

          <select
            name="categoria"
            value={formData.categoria}
            onChange={handleInputChange}
            className="form-input"
            required
          >
            <option value="">Seleccione Categoría</option>

            {cargando && <option>Cargando...</option>}

            {!cargando &&
              categorias.map((cat) => (
                <option key={cat.id} value={cat.nombre}>
                  {cat.nombre}
                </option>
              ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Estado</label>

          <select
            name="estado"
            value={formData.estado}
            onChange={handleInputChange}
            className="form-input"
          >
            <option value="True">Activo</option>
            <option value="False">Inactivo</option>
          </select>
        </div>
      </div>

      <button type="submit" className="btn-android w-100" disabled={isLoading}>
        {isLoading ? "Guardando..." : "Actualizar Producto"}
      </button>

      {mensaje && (
        <p className={`form-msg ${isSuccess ? "success" : "error"}`}>
          {mensaje}
        </p>
      )}
    </form>
  );
}
